import moment from "moment-timezone";
import { options, optionsForDate } from "../GanttInfoRenderer";
import { AbstractInfoRenderer } from "./AbstractInfoRenderer";

export class MissionEventInfoRenderer extends AbstractInfoRenderer {

    static defaultProps = {
        entityName: "MissionEvent2"
    }

    renderFieldsByDescriptorType() {
        const { entity } = this.props;
        const ed = this.getEntityDescriptor();
        const descriptorType = (entity?.descriptorType || "").toUpperCase();
        switch (descriptorType) {
            case "COMMENT":
            case "COMMENTAIRE":
                return <div className="MissionEventInfoRenderer_bold flex-container-row gap3">
                    {ed.getField("stopInfo").renderField(entity, options)}
                    {ed.getField("flight").renderField(entity, options)}
                    {ed.getField("objectActionInfo").renderField(entity, options)}
                    {ed.getField("comment").renderField(entity, options)}
                    {ed.getField("type").renderField(entity, options)}
                </div>;
            case "ALERT_COMMENTAIRE":
                return <div className="MissionEventInfoRenderer_bold flex-container-row gap3">
                    {ed.getField("comment").renderField(entity, options)}
                    {ed.getField("type").renderField(entity, options)}
                </div>;
            default:
                return <>
                    {ed.getField("generationSource").renderField(entity, options)}
                    {ed.getField("stopInfo").renderField(entity, options)}
                    {ed.getField("flight").renderField(entity, options)}
                    {ed.getField("objectActionInfo").renderField(entity, options)}
                    {ed.getField("descriptorType").renderField(entity, options)}
                </>;
        }
    }

    renderContent() {
        const { entity } = this.props;

        return <div key={entity.id} className="flex-container-row flex-center flex-wrap gap3">
            {this.getEntityDescriptor().getField("creationdate").renderField(entity, optionsForDate)}
            {this.renderFieldsByDescriptorType()}
        </div>

    }
}

export class MissionEventsInfoRenderer extends AbstractInfoRenderer {

    static defaultProps = {
        entityName: "MissionEvent2"
    }

    renderContent() {
        const events = [...(this.props.entity as any[])]
            .sort((e1, e2) => {
                if (e1.creationdate == e2.creationdate) {
                    return e1.id - e2.id;
                }
                return moment(e1.creationdate).toDate().valueOf() - moment(e2.creationdate).toDate().valueOf();
            })
            .filter(e => !e.hidden && !e.deleted);

        return <>{events.map((event) => (
            // <div key={event.id} className="very-small-padding">
            <MissionEventInfoRenderer entity={event} hideTitle />
            // </div>
        ))}</>;
    }
}
